# Candidate profile user experience guide

The files below contain an example rendering of a candidate’s profile based on SEEK’s recommended best practices.
Its design has been based on SEEK’s own profile page, which displays as an overlay drawer.

The Figma file contains a componentised example based on SEEK’s [Braid Design System].
You should tailor the design of the components to better suit your software.

The PDF file contains a pre-rendered version of the Figma file that doesn’t require dedicated software to view.

import { UxFiles } from './assets/UxFiles';

<UxFiles />

[braid design system]: https://seek-oss.github.io/braid-design-system/
